import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
        paddingTop: 0,
        paddingBottom: "12mm",
        paddingLeft: "5mm",
        paddingRight: "4mm",
        flexDirection: "row",
        justifyContent: "flex-start",
        flexWrap: "wrap",
        textAlign: "center",
    },
    sticker: {
        width: "66.6mm",
        height: "25.4mm",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "column",
    },
    divider: {
        width: "3.5mm",
        height: "25.4mm",
    },
    endOfPageDivider: {
        width: "100%",
        height: "0.7mm",
    },
    text: {
        fontSize: 10,
    },
});

const MyDocument = ({ data }) => (
    <Document>
        <Page size="LETTER" style={styles.page}>
            <View style={{ width: "100%", height: "12.7mm" }} fixed />
            {data &&
                Array.isArray(data) &&
                data.map((item, index) => {
                    return (
                        <>
                            <View style={styles.sticker}>
                                <Text
                                    style={styles.text}>{`${item.firstName} ${item.middleName} ${item.lastName}`}</Text>
                                <Text style={styles.text}>{item.address}</Text>
                                <Text style={styles.text}>{`${item.city}, ${item.state} ${item.zipCode}`}</Text>
                            </View>
                            {(index + 1) % 3 !== 0 && <View style={styles.divider} />}
                            {(index + 1) % 30 === 0 && <View style={styles.endOfPageDivider} />}
                        </>
                    );
                })}
        </Page>
    </Document>
);

export default MyDocument;
